import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import { TierType } from '@/helpers/entities/enums/v2/TierType';
import { ECOMMERCE_PRODUCT_MENU_KEY, ECOMMERCE_CART_MENU_KEY, ECOMMERCE_ORDER_MENU_KEY, CUSTOMER_SEGMENT, ECOMMERCE_MARKETING_MENU_KEY, } from '@/helpers/constants/app';
let InsuranceBundle = class InsuranceBundle extends mixins(AppDetailsMixin) {
    constructor() {
        super(...arguments);
        this.childrenMenuIcon = 'keyboard_arrow_right';
        this.toggleProductsMenu = false;
        this.toggleCartMenu = false;
    }
    get currentRoute() {
        return this.$router.currentRoute;
    }
    get cartMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_CART_MENU_KEY;
    }
    get productMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_PRODUCT_MENU_KEY;
    }
    get orderMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_ORDER_MENU_KEY;
    }
    get marketingMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_MARKETING_MENU_KEY;
    }
    get ecommerceMenuItems() {
        const params = {
            appUUID: this.appUuid,
        };
        let items = [];
        if (!!this.appDetails && !!this.appDetails.productComponent) {
            const { productComponent } = this.appDetails;
            items = [
                this.productMenu(productComponent.uuid),
                ...this.buildDefaultMenu({ ...params, componentUUID: productComponent.uuid }),
            ];
        }
        const menuItems = items.length >= 1 ? items : this.buildDefaultMenu(params);
        return [
            {
                icon_path: require('./assets/overview.svg'),
                text: 'Overview',
                path: {
                    name: 'insurance-overview',
                    params,
                },
                exact: false,
            },
            ...menuItems,
        ];
    }
    isDevelopment() {
        return (process.env.NODE_ENV === 'development' ||
            window.location.hostname !== 'app.chatgenie.ph');
    }
    isProduction() {
        return (process.env.NODE_ENV === 'production' &&
            ['302', '4410', '4610', '9439', '9442'].includes(this.checkAppId.toString()));
    }
    /**
     * Default Menu Items Builder
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.6
     *
     * @returns {Menu[]} list of menu items
     */
    buildDefaultMenu(params) {
        return [
            {
                icon_path: require('./assets/order.svg'),
                text: 'Orders',
                model: this.orderMenuIsActive,
                children: [
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Order Tracker',
                        path: {
                            name: 'insurance-orders-by-status',
                            params: { status: 'pending' },
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Order History',
                        path: {
                            name: 'insurance-order-history',
                            params,
                        },
                        exact: false,
                    },
                ],
            },
            {
                icon_path: require('./assets/broadcast.svg'),
                text: 'Marketing Tools',
                model: this.marketingMenuIsActive,
                children: [
                    ...((!!this.appDetails && this.referrable) || this.plan === TierType.ProTier
                        ? [this.referralMenu]
                        : []),
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Comment Auto-Reply',
                        path: {
                            name: 'ecommerce-affiliate-automation',
                            params,
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: CUSTOMER_SEGMENT,
                        path: {
                            name: 'insurance-customers',
                            params,
                        },
                        exact: true,
                    },
                    // {
                    //   icon: this.childrenMenuIcon,
                    //   text: 'Broadcast',
                    //   path: {
                    //     name: 'insurance-broadcasts',
                    //     params,
                    //   },
                    //   exact: false,
                    // },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Meta Ad Settings',
                        path: {
                            name: 'meta-add-settings',
                            params,
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Store Announcement Manager',
                        path: {
                            name: 'store-announcement-manager',
                            params,
                        },
                        exact: false,
                    },
                ],
            },
            {
                icon_path: require('./assets/payment.svg'),
                text: 'Discount and Promo',
                model: this.marketingMenuIsActive,
                children: [
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Discounts',
                        path: {
                            name: 'insurance-promos',
                            params,
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Promos',
                        path: {
                            name: 'insurance-cart-promos',
                            params,
                        },
                        exact: false,
                    },
                ],
            },
        ];
    }
    productMenu(productUuid) {
        const params = {
            appUUID: this.appUuid,
            componentUUID: productUuid,
        };
        return {
            icon_path: require('./assets/products.svg'),
            text: 'Product Manager',
            model: this.productMenuIsActive,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: 'Categories',
                    path: {
                        name: 'insurance-categories',
                        params,
                    },
                    exact: true,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: 'Products',
                    path: {
                        name: 'insurance-products',
                        params,
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: 'Add - Ons / Upsell',
                    path: {
                        name: 'insurance-add-ons',
                        params,
                    },
                    exact: false,
                },
            ],
        };
    }
    /**
     * Menu Item for Referral Feature
     * @author Angelo David <adavid@gorated.ph>
     * @since Version 0.51.0
     *
     * @returns {ReferralMenu} Referral Menu
     */
    get referralMenu() {
        const params = {
            appUUID: this.appUuid,
        };
        return {
            icon: '',
            text: 'Referral',
            path: {
                name: 'insurance-referral',
                params,
            },
            exact: false,
        };
    }
};
InsuranceBundle = __decorate([
    Component
], InsuranceBundle);
export default InsuranceBundle;
